import "@melloware/coloris/dist/coloris.css"
import Coloris from "@melloware/coloris"
Coloris.init()
